<script>
import Layout from '@/Shared/Layout'
export default { layout: Layout }
</script>

<script setup>
import { onMounted } from 'vue'
import { Head } from '@inertiajs/inertia-vue3'
import usePref from '@/Shared/usePref.js'

const props = defineProps({
  pref: Object,
})

onMounted(() => {
  usePref(props.pref)
})
</script>

<template>
  <div class="about campany">
    <Head title="会社概要" />
    <div>
      <h2 class="page-title text-afgreen">
        Company
        <small>会社概要</small>
      </h2>
      <div class="m-auto px-[calc(5vw_+_10px)] xs:px-[40px] sm:px-[60px] lg:px-0 max-w-[500px] sm:max-w-[640px] pb-[40px] sm:pb-[50px] lg:pb-[60px]">
        <table class="simple">
          <tbody>
            <tr>
              <th>会社名</th>
              <td>株式会社エイアンドエフ</td>
            </tr>
            <tr>
              <th>所在地</th>
              <td>
                〒160-0022 東京都新宿区新宿6丁目27番地56号 新宿スクエア<br />
                <a href="https://www.google.co.jp/maps/preview#!data=!1m4!1m3!1d6573!2d139.7088!3d35.697107!4m19!3m16!1m0!1m5!1z5p2x5Lqs6YO95paw5a6_5Yy65paw5a6_77yW5LiB55uu77yS77yX4oiS77yV77yWIOaWsOWuv-OCueOCr-OCqOOCog!2s0x60188cde44eea5d3%3A0x51ab1ce2c9bcb69e!3m2!3d35.697001!4d139.7097262!3m8!1m3!1d6573!2d139.7088!3d35.697107!3m2!1i1310!2i779!4f13.1!7m1!3b1&fid=0" target="_blank">地図はこちら<span class="arrow-right" /></a>
              </td>
            </tr>
            <tr>
              <th>設立</th>
              <td>昭和52年4月30日</td>
            </tr>
            <tr>
              <th>資本金</th>
              <td>9000万円</td>
            </tr>
            <tr>
              <th>代表者</th>
              <td>代表取締役社長　赤津　大介</td>
            </tr>
            <tr>
              <th>従業員数</th>
              <td>230名（関連会社含む）</td>
            </tr>
            <tr>
              <th>オリジナルブランド</th>
              <td>SABBATICAL、ADIRONDACK</td>
            </tr>
						<tr>
              <th>業務内容</th>
              <td>アウトドアスポーツ用品輸入販売・出版</td>
            </tr>
            <tr>
              <th>直営店舗</th>
              <td>18店舗</td>
            </tr>
            <tr>
              <th>事業所</th>
              <td>
                <ul>
                  <li>大阪営業所：〒530-0015 大阪府大阪市北区中崎西3-1-2 開成梅田ビル6F</li>
                  <li>福岡営業所：〒812-0044 福岡県福岡市博多区千代１-2-1 ブランチ博多パピヨンガーデン</li>
                  <li>札幌営業所：〒060-0032 北海道札幌市中央区北2条東4丁目 サッポロファクトリー2条館B1F</li>
                  <li>エイアンドエフ 長野物流センター 小坂田倉庫：〒399-0722 長野県塩尻市柿沢1897-1</li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
        <p class="note py-10 text-xs text-right">2023.4.01 現在</p>
      </div>
    </div>
  </div>
</template>